import request from '@/plugins/wxAxios'

// 微信支付申请列表
export const wxpayList = (params: any) => request.get('/v1/platform/wxpay/list', { params })

// 微信支付申请详情
export const wxpayDetail = (params: any) => request.post('/v1/memini/wxpay/view?shopId='+params.shopId, params)

// 获取申请状态
export const wxpayStatus = (params: any) => request.get('/v1/platform/wxpay/getStatus?shopId='+params.shopId)

// 微信支付提交审核
export const wxpaySubmit = (params: any) => request.post('/v1/platform/wxpay/submit?shopId='+params.shopId, params)

// 驳回申请
export const wxpayReject = (params: any) => request.post('/v1/platform/wxpay/reject', params)

// 审核记录
export const wxpayLogs = (params: any) => request.get('/v1/platform/wxpay/logs', { params })
